import { BackgroundToLightnessProvider, Spinner } from '@factorialco/deprecated-design-system'

import './index.styles.css'
const LoadingSpinner = () => {
  return (
    <div className={'AtsPdfViewer_loadingContainer'}>
      <BackgroundToLightnessProvider background="grey1000">
        <Spinner size="s40" />
      </BackgroundToLightnessProvider>
    </div>
  )
}

export default LoadingSpinner
